import { getDaysAfterRegistration } from 'reactApp/modules/profile/profile.selectors';
import { groupedIds } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import { ONBOARDING_STEPS_VISIBILITY_DURATION } from './onboardingSteps.constants';
import type { OnboardingState } from './onboardingSteps.types';

const getOnboardingState = (state: RootState): OnboardingState => state.onboardingSteps;

export const getOnboardingStepIndex = createSelector(getOnboardingState, (state) => state.currentStepIndex);
export const getOnboardingPanelOpen = createSelector(getOnboardingState, (state) => state.isOpen);
export const getOnboardingPanelVisible = createSelector(getOnboardingState, (state) => state.isVisible);
export const getOnboardingDownloadHintState = createSelector(getOnboardingState, (state) => state.hints.download);
export const getOnboardingSubscriptionHintState = createSelector(getOnboardingState, (state) => state.hints.subscription);
export const getOnboardingShareHintState = createSelector(getOnboardingState, (state) => !!state.hints.shareButtonId);
export const getOnboardingShareHintItemId = createSelector(getOnboardingState, (state) => state.hints.shareButtonId);
export const isOnboardingInitialized = createSelector(getOnboardingState, (state) => state.isInitialized);

export const getOnboardingUploadHintState = createSelector(getOnboardingState, (state) => state.hints.upload);

export const isOnboardingHintVisible = createSelector(
    getOnboardingState,
    (_, props) => props,
    (state, props) => state.hints.shareButtonId === props.id
);

// Первый элемент в UI списке, независимо от типа отображения в дата листе или от сортировки
export const getHomeFolderFirstChild = createSelector(
    (state: RootState) => state,
    (state) => {
        const list = groupedIds(state, EStorageType.home, false, false);
        return list?.[0];
    }
);

export const getOnboardingPeriodAvailability = createSelector(
    getDaysAfterRegistration,
    (daysAfterRegistration) => daysAfterRegistration <= ONBOARDING_STEPS_VISIBILITY_DURATION
);
